/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

import './bootstrap';

import Vue from 'vue';
import Vuetify from 'vuetify';
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';
import colors from 'vuetify/lib/util/colors';
import DatetimePicker from 'vuetify-datetime-picker';

// Route information for vue router
import Routes from '@/js/routes.js';

// Component File
import App from '@/js/views/App';

// Layout
import Default from '@/js/layouts/Default';
import NoSidebar from '@/js/layouts/NoSidebar';
import store from './store/index.js';
import http from '@/js/http';

Vue.use(http);
Vue.use(Vuetify);
Vue.use(Vuelidate);
Vue.use(DatetimePicker);

Vue.component('default-layout', Default);
Vue.component('no-sidebar-layout', NoSidebar);



import helpers from './helpers.js';
Vue.mixin({
    methods: helpers
})


// Set up storage event listener
window.addEventListener('storage', (event) => {
    if (event.key === 'jwt') {
        const newToken = event.newValue;
        store.dispatch('updateToken', newToken);
    }
});

const app = new Vue({
    el: '#app',
    store: store,
    router: Routes,
    vuetify: new Vuetify({
        theme: {
            themes: {
                light: {
                    primary: '#004AAD' // MachShip Sky Blue
                }
            }
        }
    }),
    render: h => h(App)
});

export default app;